import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../stores';
import { CircularProgress, Box } from '@mui/material';

const LoginBySLACodePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const loginByShortLivedAuthCode = useAuthStore(state => state.loginByShortLivedAuthCode);
  const { t } = useTranslation();

  const [status, setStatus] = useState('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {

    const sla_code = new URLSearchParams(location.search).get('sla_code');
    if (!sla_code) {
      setErrorMessage(t('auth.error.no_short_lived_auth_code', 'No short-lived auth code provided.'));
      setStatus('error');
      return;
    }

    const redirect_url = new URLSearchParams(location.search).get('redirect_url') || '/';

    loginByShortLivedAuthCode(sla_code).then(result => {
      if (result.success) {
          setStatus('success');
          setTimeout(() => {
            navigate(redirect_url);
          }, 2000);
        } else {
          setErrorMessage(t(result.error));
          setStatus('error');
        }
      });
  }, [location.search, navigate, loginByShortLivedAuthCode, t]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8 }}>
      {status === 'loading' && (
        <>
          <CircularProgress />
          <div>
            {t('auth.verifying', 'Verifying...')}
          </div>
        </>
      )}
      {status === 'success' && (
        <>
          <div>
            {t('auth.verified', 'User is verified! Redirecting...')}
          </div>
        </>
      )}
      {status === 'error' && (
        <>
          <div>
            {errorMessage}
          </div>
        </>
      )}
    </Box>
  );
};

export default LoginBySLACodePage;
